import { Component, ViewChild, Input } from '@angular/core';
import { Scheduler } from 'rxjs';

import { RxComponent } from 'app/core/components/common/rx.component';
import { TranslateService } from 'app/core/services/translate.service';

declare var $: any;

@Component({
    selector: 'itpx-smart-tooltip',
    templateUrl: './smart-tooltip.component.html',
    styleUrls: ['./smart-tooltip.component.css']
})
export class SmartTooltipComponent extends RxComponent {

    private readonly DefaultConfig: TooltipConfig = {
        icon: 'fa-question-circle',
        fontAwesomeStyle: 'fa',
        hoverable: true,
        hoverStyle: 'background',
        placement: 'right',
        enableHtml: true
    }

    @ViewChild('tooltip') tooltip;
    @ViewChild('content') content;

    @Input()
    private text: string;
    @Input()
    private translateKey: string;
    @Input()
    private config: TooltipConfig;

    static id = 0;
    private id: string;

    constructor(
        private translateService: TranslateService
    ) {
        super();
        this.id = 'tooltip-' + SmartTooltipComponent.id++;
    }

    ngOnInit() {

        this.config = this.config ? Object.assign(this.DefaultConfig, this.config) : this.DefaultConfig;

        this.afterViewInit()
            .observeOn(Scheduler.queue)
            .bindToLifecycle(this)
            .subscribe(_ => {
                let domElement = $(this.tooltip.nativeElement);
                if (this.translateKey || this.config.translateKey) {
                    const translateKey: string = this.translateKey || this.config.translateKey;
                    const content: string = this.translateService.translate(translateKey);
                    domElement.attr('data-content', content);
                } else if (this.config.text) {
                    domElement.attr('data-content', this.config.text);
                } else if (this.config.useDynamic) {
                    domElement.attr('data-content', this.content.nativeElement.innerHTML);
                }

                if (this.config.hoverable) {
                    domElement.attr('data-trigger', 'hover');
                }

                if (this.config.enableHtml) {
                    domElement.attr('data-html', this.config.enableHtml);
                }

                domElement.popover({
                    placement: `auto ${this.config.placement}`,
                    container: this.config.useDynamic ? `#${this.id}` : 'body'
                });
            });
    }

    ngOnDestroy() {

        super.ngOnDestroy();
        $(this.tooltip.nativeElement).popover('hide');
    }
}

export class TooltipConfig {
    icon: string;
    fontAwesomeStyle?: string = 'fa';
    hoverable: boolean;
    placement: string;
    enableHtml: boolean;
    hoverStyle: string;
    text?: string;
    translateKey?: string;
    useDynamic?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/smart-tooltip/smart-tooltip.component.ts